import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as u from './util.mjs'

export class Route extends a.MixStruct(a.Emp) {
  static spec = {
    // Short for "pattern".
    pat: u.reqRoutePattern,

    /*
    Short for "handler". Must be a function with the following signature:

      type Handler = Ctx => Promise<Response> | Response
    */
    han: a.reqFun,
  }

  pk() {return a.render(this.pat)}
}

// TODO throw exception when adding redundant route.
export class Routes extends a.ClsVec {
  get cls() {return Route}

  dict = undefined
  list = undefined

  match(rou) {
    this.index()
    const route = this.dict[rou.url.pathname]
    if (route) return route.han
    for (const route of this.list) if (rou.pat(route.pat)) return route.han
    return undefined
  }

  index() {
    if (this.dict) return
    const dict = a.Emp()
    const list = []

    for (const val of this) {
      const {pat} = val

      if (!a.isStr(pat)) {
        list.push(val)
        continue
      }

      if (!c.PROD && (pat in dict)) {
        throw Error(`redundant route ${a.show(pat)}`)
      }

      dict[pat] = val
    }

    this.dict = dict
    this.list = list
  }
}
